// const API_BASE_URL = "http://194.5.175.203/new_golpino/public/api/"
// const API_BASE_URL = "http://192.168.1.56/new_golpino/public/api/"
// const API_BASE_URL = "http://nazardoon.com/new_golpino/public/api/"
// const API_BASE_URL = "https://api.golpino.com/api/"
// const API_BASE_URL = "/api/public/api/"
const API_BASE_URL = "https://api.golpino.com/api/"
const WP_BASE_URL = "https://golpino.com/mag/api/"
// const API_BASE_URL = "http://192.168.1.56/new-golp"

export {API_BASE_URL,WP_BASE_URL}